import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AdminDealerComponent } from './admin-dealer/admin-dealer.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { CancelComponent } from './cancel/cancel.component';
import { CancelConfirmComponent } from './cancel-confirm/cancel-confirm.component';
import { ContactComponent } from './contact/contact.component';
import { EnrollComponent } from './enroll/enroll.component';
import { EnrollConfirmComponent } from './enroll-confirm/enroll-confirm.component';
import { FaqComponent } from './faq/faq.component';
import { ReportsComponent } from './reports/reports.component';
import { StatusEnrolledComponent } from './status-enrolled/status-enrolled.component';
import { ReportTiersComponent } from './report-tiers/report-tiers.component';
import { ReportMonthlyRevenueComponent } from './report-monthly-revenue/report-monthly-revenue.component';
import { ReportEnrolledComponent } from './report-enrolled/report-enrolled.component';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { TiersComponent } from './tiers/tiers.component';
import { RequestIntlComponent } from './request-intl/request-intl.component';
import { RequestIntlDealerComponent } from './request-intl-dealer/request-intl-dealer.component';
import { FleetStatusComponent } from './fleet-status/fleet-status.component';
import { DealerStatusComponent } from './dealer-status/dealer-status.component';
import { FleetCustomerComponent } from './fleet-customer/fleet-customer.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { BillingReportComponent } from './billing-report/billing-report.component';
import { PotentialBillingReportComponent } from './potential-billing-report/potential-billing-report.component';
import { FleetBillingDetailsComponent } from './fleet-billing-details/fleet-billing-details.component';

@NgModule({
    declarations: [
        AppComponent,
        AutoLoginComponent,
        HomeComponent,
        AdminDealerComponent,
        AdminHomeComponent,
        CancelComponent,
        CancelConfirmComponent,
        ContactComponent,
        EnrollComponent,
        EnrollConfirmComponent,
        FaqComponent,
        ReportsComponent,
        StatusEnrolledComponent,
        ReportTiersComponent,
        ReportMonthlyRevenueComponent,
        ReportEnrolledComponent,        
        TiersComponent,
        RequestIntlComponent,
        RequestIntlDealerComponent,
        FleetStatusComponent,
        DealerStatusComponent,
        FleetCustomerComponent,
        AccountInfoComponent,
        ForgotPasswordComponent,
        ChangePasswordComponent,
        FileUploadComponent,
        BillingReportComponent,
        PotentialBillingReportComponent,
        FleetBillingDetailsComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,        
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        FormsModule], providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule { }
